import Collection from '../../collection';
import RefBooksModule from './refbooks.module';
import Types from '../../collection/refbooks/types';
import Field from '../../model/refbooks/field';

import Config from '../../config';

import { roleA, roleC } from '../../roles';
import { hashify } from '../../utils/arrays';
import { error } from '../../ui/messages'
import { handle } from '../../service/messages';  
import { beginLock, endLock } from '../../loader';





const 
    OPEN_FIELD = 'field-form--popup',
    TOGGLE_BOUND_TYPES = 'field-form--toggle-bound-types',
    TOGGLE_NESTED_FIELDS = 'field-form--toggle-nested-fields',
    TOGGLE_BOUND_STICKERS = 'field-form--toggle-bound-stickers';





export default RefBooksModule.extend( {

    open({ field, original }) {
        if (!field.id && !field.get( 'cluster' ))
            if (this.state().cluster && this.state().cluster.id != -1)
                field.set( 'cluster', this.state().cluster );
            else if (~roleC.indexOf( Config.role() ))
                field.set( 'cluster', Config.cluster() );

        this.original = original;

        this.options.typesSorted = new Types();
        this.options.typesFiltered = new Types();
        this.options.typesResulted = new Types();

        return this.finalizeOpen( field );
    },

    onBind() {
        // rewrite originalModel with passed value
        this.originalModel = this.original || this.originalModel;
    },

    finalizeOpen(/* field */) {},

    start() {
        this.listenTo( this.model, 'change', 
            () => this.Buttons.render() );
        this.listenTo( this.model, 'change:format',
            () => this.model.set( 'default_value', '' ) );
        this.listenTo( this.model, 'change:editable_by_default',
            () => this.model.set( 'editable_inverted_for_roles', [] ) )
        this.finalizeStart( this.model );

        return this;
    },

    finalizeStart(/* field */) {},

    stop() {
        return this.stopListening( this.model ), this;
    },

    // copied from form.js
    diff(options = {}) {
        return this.model
            ? this.model.diff( this.originalModel, options )
            : [];
    },

    hasDiff(options = {}) {
        return this.diff( options ).length > 0;
    },

    events: {

        'click .-save'() {
            const onReject = message => {
                endLock( this );
                handle( this, error( message ) );
            };

            beginLock( this );

            const { result, messages } = this.Fields.validate();
            if (!result)
                return onReject( messages[0] /* [text, field] */ );

            const json = this.model.adjusted( this.originalModel, this.options );

            const fieldToSend = new Field( json );
            if (this.model.get( 'format' ) !== 'file') // no format in fieldToSend at PATCH
                fieldToSend.set( 'file_semantics', [] ),
                fieldToSend.set( 'sticker_ids', null );

            return this.options.fields.save( fieldToSend )
                    .then( attrs => new Field( attrs ) )
                    .then( 
                        (/*field*/) => this.trigger( RefBooksModule.BACK ), 
                        onReject );
        },

        'click .-close'() {
            this.trigger( RefBooksModule.BACK );
        },

    },

    [RefBooksModule.event(':bound-types:toggle')]() {
        this.trigger( TOGGLE_BOUND_TYPES,
            this.model,
            this.originalModel,
            this.state() );
    },

    [RefBooksModule.event(':nested-fields:toggle')]() {
        this.trigger( TOGGLE_NESTED_FIELDS,
            this.model,
            this.originalModel,
            this.state() );
    },

    [RefBooksModule.event(':bound-stickers:toggle')]() {
        this.trigger( TOGGLE_BOUND_STICKERS,
            this.model,
            this.originalModel,
            this.state() );
    },

    [RefBooksModule.event( 'Fields:file-semantics:toggle' )](passedSemantics) {
        const contains = this.model.get( 'file_semantics' ).includes( passedSemantics );
        const newSemantics = contains
            ? this.model.get( 'file_semantics' ).filter( ft => ft !== passedSemantics )
            : [...this.model.get( 'file_semantics' ), passedSemantics];
        this.model.set( 'file_semantics', newSemantics );
    },

    getAvailableFilteredModelIds(collection) {
        const models = collection instanceof Collection
            ? collection.models
            : collection;
    
        return models
            // ignore unavailable (disabled) checkboxes
            .filter( type => 
                // chief admin may check any MODEL
                // (local MODELS of wrong cluster do not pass filtration)
                roleA.includes( Config.role() ) ||
                // local MODELS may be checked anyway
                // (local MODELS of wrong cluster do not pass filtration)
                type.get( 'cluster' ) ||
                // local field may be joined to any MODEL
                // (local MODEL of wrong cluster do not pass filtration)
                this.model.get( 'cluster' ) )
            .map( type => type.id );
    }
    
}, {

    OPEN_FIELD,

    TOGGLE_BOUND_TYPES,

    TOGGLE_NESTED_FIELDS,

    TOGGLE_BOUND_STICKERS,

} );



// WEBPACK FOOTER //
// ./src/js/module/refbooks/fields.form.template.js